<template>
  <DialogHeader>
    <template #right>
      <div class="font-medium text-green-900 cursor-pointer" @click="close()">
        Done
      </div>
    </template>
    Transaction history
  </DialogHeader>
  <DialogContent>
    <div
      class="font-primary leading-[16px] tracking-[-0.2px] text-black mb-[14px]"
    >
      History of your copyright since it was created.
    </div>
    <TransactionCard
      v-for="(transaction, index) in props.transactions"
      :key="index"
      :transaction="transaction"
      class="mb-2.5 last:mb-0"
    />
  </DialogContent>
  <DialogFooter>
    <UiButton class="w-1/2 tablet-h:w-auto" primary @click="close()">
      Done
    </UiButton>
  </DialogFooter>
</template>

<script setup lang="ts">
import { UiButton } from '@dacr/ui'
import DialogHeader from '@/shared/dialogs/DialogHeader.vue'
import DialogContent from '@/shared/dialogs/DialogContent.vue'
import DialogFooter from '@/shared/dialogs/DialogFooter.vue'
import { useDialog } from '@/shared/dialogs/useDialog'
import type { Transaction } from '@/shared/graphql/legacy/generated'
import TransactionCard from '@/features/billing/components/TransactionCard.vue'

const props = defineProps<{
  transactions: Transaction[]
}>()

const { close } = useDialog()
</script>
